module.exports = __webpack_public_path__ + "components/country-flag/static/cz-1a8f46466827b0a6437d47abccd3a6a8.svg";